import "./console";

// import 'htmx.org';
import 'hyperscript.org';

import htmx from 'htmx.org';
window.htmx = htmx;
htmx.config.refreshOnHistoryMiss = true;

window._hyperscript = require('hyperscript.org');
window._hyperscript.browserInit();

import * as Views from "./views";
import * as Cache from "./cache";
import * as Popover from "./ui/popovers";
import * as GA from "./google-analytics";
import * as Video from "./video_fallback";


initApp();

function initApp() {

  window._wq = window._wq || [];
  // Regardless of how many videos are on the page, this function will attach 
  // the tracking event to every video's 'play' event.
  _wq.push({ id: "_all", onReady: function(video) {
    video.bind('play', function() {

      let isAutoplay = video._attrs.autoplay,
        options = {action: "Video", category: "Help-FAQ", label: video.name()};

      if(isAutoplay === false) {
        options.value = "autoplay";
      }

      GA.trackGoogleEvent(options);
    });

  }});

  document.body.addEventListener('htmx:configRequest', (event) => {
    event.detail.headers['X-CSRF-Token'] = document.querySelector("input[name=__anti-forgery-token]").value;
  });

  document.addEventListener("DOMContentLoaded", function () {
    Cache.handleBackForwardCacheDomState();
    Views.initView();
    GA.initPageElements();
    GA.trackLoginEvent();
    Video.initVideoFallback();
  });

  Popover.initPopovers();
  Popover.initTriggerlessPopovers();

  document.addEventListener("click", (evt) => {
    let el = evt.target;
    
    if(el.dataset.preventDefault || el.closest("[data-prevent-default]")) {
      evt.preventDefault();
      return true;
    }
  });

  document.addEventListener('htmx:historyCacheError', function(evt) {
    console.error(evt.detail.cause);
  });

  document.addEventListener('htmx:responseError', function(evt) {
    let {detail} = evt;

    console.log(detail.xhr.response);

    let contentType = detail.xhr.getResponseHeader("Content-Type");
    let jsonResponse = contentType === 'application/json' ? JSON.parse(detail.xhr.response) : null;

    if(detail.xhr.status === 403 && jsonResponse?.reason === "anti-forgery-error") {
      alert("Your session has expired, please reload the page and try again.");
    }
    else if(detail.boosted && detail.elt.tagName === 'FORM') {
      // display an error message for form submissions
      alert('An error occurred! Please try again.');
    }
  });
}

function initAsyncVideoFallback() {
  Video.initVideoFallback();
}

window.initAVF = initAsyncVideoFallback;

export const Download = require('./download');
export const UI = require('./ui');

